'use strict';

const $ = require('jquery');
const util = require('../utils/util');
const page = require('../components/page');
const packstation = require('../components/packstation');
const accountTracking = require('../components/tracking/account');

/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
const toggleFullOrder = function () {
    $('.order-items')
        .find('li.hidden:first')
        .prev('li')
        .append('<a class="toggle">View All</a>')
        .children('.toggle')
        .click(function () {
            $(this).parent().siblings('li.hidden').show();
            $(this).remove();
        });
};

/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
const initPaymentEvents = function () {
    const paymentList = $('.payment-list');

    if (paymentList.length === 0) {
        return;
    }

    util.setDeleteConfirmation(paymentList, String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD));

    $('form[name="payment-remove"]').on('submit', function (e) {
        e.preventDefault();
        // override form submission in order to prevent refresh issues
        const button = $(this).find('.delete');

        $('<input/>')
            .attr({
                type: 'hidden',
                name: button.attr('name'),
                value: button.attr('value') || 'delete card'
            })
            .appendTo($(this));

        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: $(this).serialize()
        }).done(function () {
            page.redirect(Urls.paymentsList);
        });
    });
};

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
const initializeEvents = function () {
    toggleFullOrder();
    initPaymentEvents();
    packstation.isCheckout = false;
    packstation.updateShippingForPackstation(); // init packstation after form submit
    packstation.initResize();

    // if the user just created their account - send an event to dataLayer
    const registrationURLRegex = /registration=true&regsource=([a-zA-Z]+)/;
    const registrationURLMatches = window.location.href.match(registrationURLRegex);

    if (registrationURLMatches) {
        var myAccountSignupStep = registrationURLMatches[1];

        if (window.history && window.history.replaceState && typeof window.history.replaceState === 'function') {
            // remove the GET param to make sure back/refresh buttons don't trigger the event again
            window.history.replaceState({}, document.title, location.href.replace(registrationURLRegex, ''));
        }

        if (window.dataLayer) {
            const eventObject = {
                event: 'myAccountSignup',
                myAccountSignupStep: myAccountSignupStep
            };

            if (typeof window.gtmSignupStore === 'object') {
                eventObject.triggeredSignupStore = window.gtmSignupStore.triggeredSignupStore;
                eventObject.chosenSignupStore = window.gtmSignupStore.chosenSignupStore;

                delete window.gtmSignupStore;
            }
            window.dataLayer.push(eventObject);
        }
    }

    // if the user just created their account and subscribed to NL - send an event to dataLayer
    if (document.location.href.indexOf('newsletter=subscribed') > -1) {
        if (window.history && window.history.replaceState && typeof window.history.replaceState === 'function') {
            // remove the GET param to make sure back/refresh buttons don't trigger the event again
            window.history.replaceState({}, document.title, location.href.replace('newsletter=subscribed', ''));
        }

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'newsletterSignup_accountCreation',
                newsletterSignupStep: 'CreateAccountPage'
            });
        }
    }
};

const account = {
    init: function () {
        initializeEvents();

        const subPages = {
            overview: require('./account/overview'),
            myorders: require('./account/orderhistory'),
            myprofile: require('./account/personaldata'),
            newsletter: require('./account/newsletter')
        };

        if (window.pageContext && window.pageContext.subPage && subPages[window.pageContext.subPage]) {
            subPages[window.pageContext.subPage].init();
        }

        accountTracking.init();
    }
};

module.exports = account;
